export class SessionConfig {
  static prefix = 'nirwanji.dashboard.';
  static persist = true;
}
